import { Stack, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-premium';

export const textRenderCell = (params: GridRenderCellParams) => (
  <Stack
    justifyContent="center"
    sx={{
      height: '100%',
      width: '100%',
      minWidth: 0
    }}>
    <Typography
      sx={{
        fontSize: '0.8125rem',
        fontWeight: 400,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }}>
      {params?.value ?? '—'}
    </Typography>
  </Stack>
);
